import { datadogLogs } from '@datadog/browser-logs'
import { LogLevel } from '@messenger/consts'
import type { LogData, LogLevelType } from '@messenger/types'

const isDevelopment = process.env.REACT_APP_ENV === 'development'

const formatLog = (level: LogLevelType, data: LogData) => {
  const { error, ...rest } = data

  return {
    timestamp: new Date().toISOString(),
    level,
    ...rest,
    error: error
      ? {
          message: error.message,
          name: error.name,
          stack: error.stack,
        }
      : undefined,
  }
}

const logMessage = (level: LogLevelType, data: LogData) => {
  if (isDevelopment) return
  const { message } = data
  const formattedLog = formatLog(level, data)
  const { error, ...log } = formattedLog

  switch (level) {
    case LogLevel.ERROR:
      datadogLogs.logger.error(message, log, error)
      break
    case LogLevel.WARN:
      datadogLogs.logger.warn(message, log, error)
      break
    case LogLevel.INFO:
      datadogLogs.logger.info(message, log, error)
      break
    case LogLevel.DEBUG:
      datadogLogs.logger.debug(message, log, error)
      break
  }
}

export const logger = {
  error: (data: LogData) => logMessage(LogLevel.ERROR, data),
  warn: (data: LogData) => logMessage(LogLevel.WARN, data),
  info: (data: LogData) => logMessage(LogLevel.INFO, data),
  debug: (data: LogData) => logMessage(LogLevel.DEBUG, data),
}

// Export the constants and types for convenience
export { LogLevel, EventCategory } from '@messenger/consts'
export type { LogData, LogLevelType, EventCategoryType } from '@messenger/types'
